import { KnownRole } from "../../types/models/KnownRole";
import { KnownLocation } from "../../types/models/KnownLocation";
import { RoleBundle } from "../../types/models/RoleBundle";

export const getRoleDisplayName = (roleId: string, knownRoles: KnownRole[] | undefined) =>
  knownRoles?.find((role) => role.RoleId === roleId)?.DisplayName ?? roleId;

export const getRoleBundleDisplayName = (
  roleBundleId: string,
  roleBundles: RoleBundle[] | undefined
) => roleBundles?.find((bundle) => bundle.Id === roleBundleId)?.DisplayName ?? roleBundleId;

export const getLocationDisplayName = (
  lniId: string,
  knownLocations: KnownLocation[] | undefined
) => knownLocations?.find((location) => location.LNIId === lniId)?.Name ?? lniId;
